import { Component, Vue } from 'vue-property-decorator'
import DefaultLayout from '@/components/Layouts/Default'
import GameFooter from '@/components/Game/Footer';
import { Auth } from 'aws-amplify';
import { EventBus } from '@/utils/eventbus';
import Axios from 'axios';
import { config } from '@/../app.config'
import _ from 'lodash';
import { StripTheGarbage, FormatDollars, GetGeoData, FormatCurrency } from '@/utils/GameUtils';
import { IPaymentSession } from './Account';
import { ErrorMessageLookup } from '@/utils/GameUtils'

@Component
export default class Withdrawal extends Vue {

  /*private ErrorMessageLookup: {[s: number]: string} = {
    0: 'There has been a problem with your request, please contact support',
    1: `Withdrawals aren't currently supported in your geographic location`,
    10: `Your balance is insufficient to withdraw the requested amount`,
    11: `You still have rollover balance to use before you can withdraw`,
    12: `We're currently unable to create a request with the payment processor. Please try again later`,
    13: `Your account could not be validated. Please logout and try again`,
    15: `Invalid withdrawal amount, please try again`
  }*/

  private userAmount: number = 10
  private userAmountVis: string = this.userAmount.toFixed(2)

  private invalidState = false
  private isSubmitting = false

  private async withdrawal() {
    if (this.isSubmitting) { return; }

    //@ts-ignore
    heap.track('account:withdrawal:init')
    this.isSubmitting = true;
    const geoBundle = await GetGeoData()
    
    Axios.post(`${config.apiEndpoint}/auth/withdrawal`, {
      geo: geoBundle,
      amount: this.userAmount
    })
    .then( (res) => {
      const payload = res.data as IPaymentSession
      this.gatewayPayload = payload
      this.buildPaymentGatewayScriptTag(payload.sessionurl)
      this.isSubmitting = false
    })
    .catch( (err) => {
      this.isSubmitting = false
      if (err.response.data && err.response.data.code) {
        //@ts-ignore
        heap.track('account:withdrawal:failure', {'code': err.response.data.code})
        const error = ErrorMessageLookup()[err.response.data.code] || ErrorMessageLookup()[0]
        //@ts-ignore
        this.genErrorDialog(error)
        return;
      }
      // @ts-ignore
      this.genErrorDialog('Could not connect to the account gateway. Please try again later')
    })
  }

  private genErrorDialog(msg: string) {
    this.$modal.show('dialog', {
      text: msg,
      buttons: [
        {
          title: 'Close'
        }
     ],
    })
  }

  private buildPaymentGatewayScriptTag(sessionURL: string) {
    const node = decodeURIComponent(sessionURL.replace(/\+/g,  ' '))
    const range = document.createRange()
    const documentFragment = range.createContextualFragment(node)
    document.body.appendChild(documentFragment)
    document.body.classList.add('payment-active')
  }

  gatewayPayload: IPaymentSession | null

  private onPress(evt: KeyboardEvent) {
    StripTheGarbage(evt)
    if (FormatDollars(this.userAmountVis) >= 10) {
      this.invalidState = false
    } else {
      this.invalidState = true
    }
  }

  private clearNodes() {
    const scr = document.querySelector('script[data-tsevo-script-tag]')
    if (scr && scr.parentNode) {
      scr.parentNode.removeChild(scr)
      document.body.classList.remove('payment-active')
    }

    const gdx = document.querySelector('#GIDX_ServiceContainer')
    if (gdx) {
      Array.from(gdx.children).forEach( (child) => {
        if (!child.classList.contains('lds-grid')) {
          child.remove()
        }
      })
    }
  }

  private toggleLoader(show: boolean) {
    const scr = document.querySelector('.lds-grid')
    if (scr) {
      if (show) { 
        scr.classList.add('hidden')
        return
      }
      scr.classList.remove('hidden')
    }
  }

  private created() {
    EventBus.$on('paymentSessionStarted', () => {
      this.toggleLoader(true)
    })

    EventBus.$on('paymentSessionComplete', () => {
      this.gatewayPayload = null
      this.clearNodes()
      this.toggleLoader(false)
    })

    EventBus.$on('paymentSessionError', () => {
      this.gatewayPayload = null
      setTimeout(() => {
        this.toggleLoader(false)
        this.clearNodes()
      }, 5000)
    })
  }

  private beforeDestroy() {
    this.clearNodes()
    this.toggleLoader(false)
    this.gatewayPayload = null
  }

  private render(h: any) {
    const balance = `$${this.$store.getters.BALANCE}`

    let buttonContent = <span>Request Withdrawal</span>

    if (this.isSubmitting) {
      buttonContent = <div class='lds-ellipsis'><div></div><div></div><div></div><div></div></div>
    }

    return (
        <DefaultLayout>
          <div id='GIDX_ServiceContainer'>
            <div class='lds-grid dark'><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
          </div>

          <div slot='navigation'>
            <h1 class='navigation-title'>{this.$route.meta.title}</h1>
            <router-link class='navigation-link home' to='/account'>Account</router-link>
            <p class='navigation-user'>{this.$store.getters.USERNAME}</p>
            <router-link class='navigation-balance' to='/account'>{`${FormatCurrency(this.$store.getters.BALANCE)}`}</router-link>
          </div>

          <div class='account-balance'>
          <span>Balance</span>
            <p class='account-balance-amount'>{balance}</p>
          </div>

          <div class='withdrawal-submit'>
            <div class='button-bar light'>
              <div class='input-wrapper'>
                <span class='input-prefix'>$</span>
                <input type='number' 
                  vModel={this.userAmountVis}
                  on-input={(evt: KeyboardEvent) => this.onPress(evt)}
                  onBlur={() => {
                    this.userAmount = FormatDollars(this.userAmountVis)
                  }}
                  step='any' min='1' class='fbutton finput button-action'></input>
              </div>
            </div>
            <div class='withdrawal-place'>
              <button onClick={this.withdrawal.bind(this)} class='fbutton button-action wide' disabled={this.invalidState}>
                {buttonContent}
              </button>
            </div>
          </div>
          <GameFooter></GameFooter>
        </DefaultLayout>
    );
  }
}
